import React, { useMemo } from 'react'
import { Badge, RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildBankruptcies } from './bankruptciesModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function Bankruptcies({ bankruptcies, owner, showSummary = true }) {
    const model = useMemo(() => buildBankruptcies(bankruptcies, owner), [bankruptcies, owner])
    const { summary, rows } = model

    if (!rows.length) return <div className={styles.calmLine}>No bankruptcies found.</div>

    const latest = summary.latest
    return (
        <div className={styles.uccList}>
            {showSummary && (
                <div className={styles.inlineBadges}>
                    <Badge tone={summary.recent || summary.open ? 'declined' : 'neutral'} dot={summary.recent > 0 || summary.open > 0}>
                        {plural(summary.count, 'bankruptcy', 'bankruptcies')}
                        {latest ? ` · latest ${[latest.year, latest.chapter && `chapter ${latest.chapter}`, latest.outcome.toLowerCase()].filter(Boolean).join(', ')}` : ''}
                    </Badge>
                    {summary.recent > 0 && <Badge tone='declined'>{summary.recent} in the last 7 years</Badge>}
                </div>
            )}
            <div className={styles.note}>
                Lexis matches bankruptcies by name. Open a case to see whether a debtor's SSN matches the owner.
            </div>
            <RecordList items={rows} />
        </div>
    )
}
